module.exports = __webpack_public_path__ + "static/media/service-img-10.a17b34de.png";